module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "pn"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _vm._v("Part One")]), _vm._v(" "), _c('h2', {
    staticClass: "pt"
  }, [_vm._v("India to the War Office")]), _vm._v(" "), _c('div', {
    staticClass: "ext"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Part1"
    }
  }, [_vm._v("Part One")]), _vm._v(" traces Pug Ismay’s life from his family background, through school to Sandhurst and out to fight on the North-West Frontier. He reluctantly missed the Great War by fighting with the Camel Corps in Somaliland, after which he married, returned to India and attended Staff College. He had a brief spell in the Indian equivalent of the War Office (Simla), then to the London Whitehall War Office, hoping for a military command but was sent in a ceremonial military role back to India to assist Viceroy Willingdon. He was invited back to London under the guidance of Maurice Hankey, where slowly but surely his character and aptitudes were noticed, and by 1939 he became a key component in the war administration. From fighting tribesmen in North-West India and Somaliland, he had suddenly risen to be close to the centre of administrative power during the whole of the Second World War.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dc247a12","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Part1.vue
// module id = 75
// module chunks = 0